import checkIcon from "../../../assets/icons/check-circle.png";
import timesIcon from "../../../assets/icons/times-circle.png";

import DefaultImage from "../Image/DefaultImage";
import Image from "../Image/Image";

import styles from "./Card.module.css";

function Card({ image, imageStyles, description = "Description", disabled }) {
	const cardStyles = disabled
		? [styles.card, styles.disabled].join(" ")
		: styles.card;
	const iconStyles = disabled
		? [styles.icon, styles.disabled].join(" ")
		: styles.icon;
	const cardIcon = disabled ? timesIcon : checkIcon;
	const labelStyles = disabled
		? [styles.label, styles.disabled].join(" ")
		: styles.label;

	return (
		<div className={cardStyles}>
			{!image && <DefaultImage />}
			{image && (
				<Image
					src={image}
                    customStyle={imageStyles}
					alt={description}
				/>
			)}
			<div className={styles.labelContainer}>
				<img
					src={cardIcon}
					className={iconStyles}
					alt=""
				/>
				<div className={labelStyles}>{description}</div>
			</div>
		</div>
	);
}

export default Card;
